
import { 
    DOOH_REPORT_ADVERTISER,
    DOOH_REPORT_CAMPAIGN,
    DOOH_REPORT_OUTLETS,
    DOOH_REPORT_LOADER,
    END_URL
} from './config';
import axios from 'axios';
import { API_URL } from '../../config/globals';
axios.defaults.baseURL = API_URL;

export const getCampaign = (id) => {
    return (dispatch) => {
        const url = id ? `${END_URL.CAMPAIGN}/${id}` : `${END_URL.CAMPAIGN}`;
        axios.get(url)
        .then(res => {
        if(res.data){
            dispatch({ type: DOOH_REPORT_CAMPAIGN, payload: res.data });
        }
        }).catch((error)=>{
            console.log(error)
        }) 
    }
}

export const getAdvertiser = (id) => {
    return (dispatch) => {
        const url = id ? `${END_URL.ADVERTISERS}/${id}` : `${END_URL.ADVERTISERS}`; 
        axios.get(url)
        .then(res => {
            dispatch({ type: DOOH_REPORT_ADVERTISER, payload: {data:res.data} });
        }).catch((error)=>{
            console.log(error)
        })
        
       
    }
}

export const getOutlets = (id) => {
    return (dispatch) => {
        const url = id ? `${END_URL.OUTLET}/${id}` : `${END_URL.OUTLET}`;
        axios.get(url)
        .then(res => {
            dispatch({ type: DOOH_REPORT_OUTLETS, payload:res.data});
        }).catch((error)=>{
            console.log(error)
        })
        
        
    }
}

export const loaderActions = (action) => {
    return (dispatch) => {
        dispatch({ type: DOOH_REPORT_LOADER, payload:action});     
    }
}
// export const clearLoader = function () {
//     return ({
//         type: CLEAR_NOTIFICATION
//     });
// }